export default __webpack_public_path__ + "static/top_point_img_001-567629eda758306e10b2f77e9bd4ef43.jpg";